import { render, staticRenderFns } from "./SectionFewFacts.vue?vue&type=template&id=0df052a1&"
import script from "./SectionFewFacts.vue?vue&type=script&lang=js&"
export * from "./SectionFewFacts.vue?vue&type=script&lang=js&"
import style0 from "./SectionFewFacts.vue?vue&type=style&index=0&id=0df052a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomFacts: require('/app/components/atoms/common/AtomFacts.vue').default})
